import React, { useEffect, useState } from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
import LazyLoad from 'react-lazyload';
function Activities() {
    return (
        <>
            <Header />
            {/* Inner Slider */}
            <section class="inr-header">
                <div class="container">
                    <div class="inr-header-content">
                        <h1 class="title">Activities</h1>
                        <ul class="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li> Activities</li>
                        </ul>
                    </div>
                </div>
            </section>
            {/*  Inner Body */}

            <section className="innerBody">
                <div className="container them-container">
                    <div className="row">
                        <div className="col-12">
                            <h1>Curricular Activities</h1>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <p>In order to inculcate in students the spirit of acquiring various skills and also to create an
                                atmosphere of competitiveness, sportsmanship and team work, students are encouraged to take part
                                in various competitions like drawing/colouring, elocution, singing, calligraphy, fancy dress,
                                etc. These competitions are held annually and winners of these interclass competitions are
                                honoured with certificates and mementoes.</p>
                            <p>Special assemblies are conducted on important days like, Independence Day, Children’s Day,
                                Teacher’s day and Republic Day to make students aware of the significance of these days.</p>
                            <p>To promote healthy living and wellness among the students, Yoga and physical exercises are given
                                due importance. Mass P.T for all classes is conducted during Wednesday assembly.</p>
                            <p>An annual sport is a regular feature and participation of all students is encouraged. Various
                                sports events are held in a day long programme. Medals and certificates are given to the
                                winners.</p>
                        </div>
                    </div>
                    <div className="row imgthumb">
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SMNSB/public/images/act1.jpg">
                                <LazyLoad> <img src="https://webapi.entab.info/api/image/SMNSB/public/images/act1.jpg" className="img-fluid mx-auto d-block" alt="Tejswini Vidya Mandir, Nagpur" /></LazyLoad>
                            </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SMNSB/public/images/act2.jpg">
                                <LazyLoad> <img src="https://webapi.entab.info/api/image/SMNSB/public/images/act2.jpg" className="img-fluid mx-auto d-block" alt="Tejswini Vidya Mandir, Nagpur" /></LazyLoad>
                            </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SMNSB/public/images/act3.jpg">
                                <LazyLoad> <img src="https://webapi.entab.info/api/image/SMNSB/public/images/act3.jpg" className="img-fluid mx-auto d-block" alt="Tejswini Vidya Mandir, Nagpur" /></LazyLoad>
                            </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SMNSB/public/images/act4.jpg">
                                <LazyLoad> <img src="https://webapi.entab.info/api/image/SMNSB/public/images/act4.jpg" className="img-fluid mx-auto d-block" alt="Tejswini Vidya Mandir, Nagpur" /></LazyLoad>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            <div className="clr100"></div>
            {/* Footer */}
            <Footer />
        </>
    )
}

export default Activities